const sortRoles = roles =>
  roles.sort((role) => {
    switch (role.Name) {
      case 'Master Administrator':
        return -1;
      case 'Administrator':
        return 0;
      default:
        return 1;
    }
  });

export default sortRoles;



// WEBPACK FOOTER //
// ./src/utils/sortRoles.js